import { computed, ref, watch, onMounted } from 'vue-demi';
import ResizeObserver from 'resize-observer-polyfill';
const { debounce } = require('@futuweb/fego-bridge');

export default ({headerRef, activeId, resizable}) => {
    const activeBarHeight = ref(0);
    const activeBarTop = ref(0);
    // 最后作用的样式
    const headerActiveBarStyle = computed(() => {
        return {
            height: activeBarHeight.value + 'px',
            transform: `translateY(${activeBarTop.value}px)`
        };
    });

    const resetHeaderBar = debounce(() => {
        if (headerRef.value) {
            const element = headerRef.value.querySelector('.vertical-anchor-tab-part.active');
            const { top, height } = element.getBoundingClientRect();
            const { top: parentTop } = element.parentElement.getBoundingClientRect();
            activeBarHeight.value = height;
            activeBarTop.value = top - parentTop;
        }
    }, 100);

    let headerObserver;
    const observeHeader = () => {
        headerObserver = new ResizeObserver((entries) => {
            resetHeaderBar();
        });
        if (headerRef.value) {
            headerObserver.observe(headerRef.value);
        }
    };
    resizable && onMounted(observeHeader);


    // 监听当前激活标题，同步设置 headerBar
    watch(
        activeId,
        () => {
            resetHeaderBar();
        },
        { immediate: true }
    );

    return {
        headerActiveBarStyle,
        headerRef
    };
};
